
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../Components/Ui/tables/Actions";


const useTableColumns :any = () => {
  const [t] = useTranslation();
    return useMemo(
    () => [
 
      {
        name: t("id"),
        sortable: true,
        center: true,
        selector: (row: any) => row.id, 
      }, 
      {
        name: t("name"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.name
      },
      {
        name: t("email"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.email
      },

      {
        name: t("message"),
        sortable: false,
        center: "true",
        cell: (row:any) => <div className="single-line-div">{row?.message} </div> 
      },
      {
        name: "#",
        sortable: false,
        center: true,
        cell: (row:any) => (
          <Actions
            objectToEdit={row}
            showEdit={false}
            showView={false}
            showDelete={false}
          >  
          </Actions>
        ),
      },

    ],
    [t]
  );
};

export default useTableColumns;

